import { HistoryUpdate } from 'api/history'
import * as Model from 'api/model'

export const CONFIG_MANAGER_OPEN = 'CONFIG_MANAGER_OPEN'
export const CONFIG_MANAGER_CLOSE = 'CONFIG_MANAGER_CLOSE'

export const configManagerOpen = () => {
  Model.setState('config', null, true)
  HistoryUpdate()
  return {
    type: CONFIG_MANAGER_OPEN
  }
}

export const configManagerClose = () => {
  Model.unset('app.state.config')
  HistoryUpdate()
  return {
    type: CONFIG_MANAGER_CLOSE
  }
}
